// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-card .table-title[data-v-73696bc1] {\n  font-size: 16px;\n  background: #edd4b6;\n  height: 40px;\n  padding: 0 10px;\n  font-weight: 500;\n}\n.table-card .table-title .title[data-v-73696bc1] {\n  font-size: 14px;\n  color: #333333;\n}", ""]);
// Exports
module.exports = exports;
